/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { ConfigurationEntity } from '../model/configurationEntity';
import { IndNewVehModel } from '../model/indNewVehModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {baseUrl}from '../../../environments/environment';

@Injectable()
export class ConfigurationControllerService {

    protected basePath = baseUrl;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * addRule
     * 
     * @param configurationEntities configurationEntities
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addRuleUsingPOST(configurationEntities: Array<ConfigurationEntity>, observe?: 'body', reportProgress?: boolean): Observable<Array<ConfigurationEntity>>;
    public addRuleUsingPOST(configurationEntities: Array<ConfigurationEntity>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ConfigurationEntity>>>;
    public addRuleUsingPOST(configurationEntities: Array<ConfigurationEntity>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ConfigurationEntity>>>;
    public addRuleUsingPOST(configurationEntities: Array<ConfigurationEntity>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (configurationEntities === null || configurationEntities === undefined) {
            throw new Error('Required parameter configurationEntities was null or undefined when calling addRuleUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<ConfigurationEntity>>(`${this.basePath}configuration/addRule`,
            configurationEntities,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteRule
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteRuleUsingDELETE(id: string, observe?: 'body', reportProgress?: boolean): Observable<ConfigurationEntity>;
    public deleteRuleUsingDELETE(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ConfigurationEntity>>;
    public deleteRuleUsingDELETE(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ConfigurationEntity>>;
    public deleteRuleUsingDELETE(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteRuleUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<ConfigurationEntity>(`${this.basePath}configuration/deleteRule/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * editRule
     * 
     * @param configurationEntity configurationEntity
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editRuleUsingPOST(configurationEntity: ConfigurationEntity, observe?: 'body', reportProgress?: boolean): Observable<ConfigurationEntity>;
    public editRuleUsingPOST(configurationEntity: ConfigurationEntity, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ConfigurationEntity>>;
    public editRuleUsingPOST(configurationEntity: ConfigurationEntity, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ConfigurationEntity>>;
    public editRuleUsingPOST(configurationEntity: ConfigurationEntity, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (configurationEntity === null || configurationEntity === undefined) {
            throw new Error('Required parameter configurationEntity was null or undefined when calling editRuleUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ConfigurationEntity>(`${this.basePath}configuration/editRule`,
            configurationEntity,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * fetchRules
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchRulesUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<ConfigurationEntity>>;
    public fetchRulesUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ConfigurationEntity>>>;
    public fetchRulesUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ConfigurationEntity>>>;
    public fetchRulesUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ConfigurationEntity>>(`${this.basePath}configuration/fetchRules`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * fetchVehicleModels
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchVehicleModelsUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<IndNewVehModel>>;
    public fetchVehicleModelsUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<IndNewVehModel>>>;
    public fetchVehicleModelsUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<IndNewVehModel>>>;
    public fetchVehicleModelsUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<IndNewVehModel>>(`${this.basePath}configuration/fetchVehicleModels`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
